/*!
 * devextreme-react
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("devextreme/core/utils/common");

var TemplateUpdater =
/** @class */
function () {
  function TemplateUpdater(updateTemplatesCallback) {
    this._templates = {};
    this._updateIsDelayed = false;
    this._updateTemplatesCallback = updateTemplatesCallback;
    this._scheduleUpdate = this._scheduleUpdate.bind(this);
    this.setTemplate = this.setTemplate.bind(this);
    this.removeTemplate = this.removeTemplate.bind(this);
  }

  TemplateUpdater.prototype.setTemplate = function (templateId, templateFunc) {
    this._templates[templateId] = templateFunc;

    this._scheduleUpdate();
  };

  TemplateUpdater.prototype.removeTemplate = function (templateId) {
    delete this._templates[templateId];

    this._scheduleUpdate();
  };

  TemplateUpdater.prototype._scheduleUpdate = function () {
    var _this = this;

    if (this._updateIsDelayed) {
      return;
    }

    this._updateIsDelayed = true;
    common_1.deferUpdate(function () {
      _this._updateTemplatesCallback(_this._templates);

      _this._updateIsDelayed = false;
    });
  };

  return TemplateUpdater;
}();

exports.TemplateUpdater = TemplateUpdater;